/* Imports */

import React, { useLayoutEffect } from "react";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import * as am5plugins_exporting from "@amcharts/amcharts5/plugins/exporting";
import am5locales_fa_IR from "../../Assets/lang/fa_IR";
import moment from "moment-jalaali";
import Loader from "../../Loader";
import { useSelector } from "react-redux";

function ByPanelDailyChartData({ data, dateHOC, loading, }) {
  const lang_choiced = useSelector((state) => state.lang_change);

  // console.log(data, "is data");
  useLayoutEffect(() => {
    let root = am5.Root.new("ByPanelDailyChartData");

    // Set themes
    // https://www.amcharts.com/docs/v5/concepts/themes/
    root.setThemes([am5themes_Animated.new(root)]);
    root.locale = am5locales_fa_IR;
    // Create chart
    // https://www.amcharts.com/docs/v5/charts/xy-chart/
    let chart = root.container.children.push(
      am5xy.XYChart.new(root, {
        layout: root.verticalLayout,
        focusable: true,
        panX: true,
        panY: true,
        wheelX: "panX",
        wheelY: "zoomX",
        pinchZoomX: true,
      })
    );

    let exporting = am5plugins_exporting.Exporting.new(root, {
      menu: am5plugins_exporting.ExportingMenu.new(root, {
        align: "right",
        valign: "bottom",
        items: [
          {
            type: "format",
            format: "jpg",
            label: "Export image",
          },
          {
            type: "format",
            format: "pdfdata",
            label: "Export JSON",
          },
          {
            type: "separator",
          },
          {
            type: "format",
            format: "print",
            label: "Print",
          },
        ],
      }),
    });

    let easing = am5.ease.linear;
    chart.get("colors").set("step", 3);

    let date1 = new Date(
      moment(new Date(dateHOC[0])).format("jYYYY-jMM-jDDTHH:mm:ss")
    );
    let date2 = new Date(
      moment(new Date(dateHOC[1])).format("jYYYY-jMM-jDDTHH:mm:ss")
    );
    let firstDate, newdate;
    if (date1 > date2) {
      firstDate = date2;
      newdate = date1;
    } else {
      firstDate = date1;
      newdate = date2;
    }
    firstDate.setHours(0);
    firstDate.setMinutes(0);
    firstDate.setSeconds(0);
    newdate.setMinutes(59);
    newdate.setSeconds(59);
    newdate.setHours(23);
    // console.log(
    //   dateHOC[0],
    //   dateHOC[1],
    //   "\n",
    //   firstDate,
    //   newdate,
    //   "is chart date"
    // );
    const minDate = new Date(
      Date.UTC(
        firstDate.getUTCFullYear(),
        firstDate.getUTCMonth(),
        firstDate.getUTCDate(),
        firstDate.getUTCHours(),
        firstDate.getUTCMinutes(),
        firstDate.getUTCSeconds()
      )
    );
    const maxDate = new Date(
      Date.UTC(
        newdate.getUTCFullYear(),
        newdate.getUTCMonth(),
        newdate.getUTCDate(),
        newdate.getUTCHours(),
        newdate.getUTCMinutes(),
        newdate.getUTCSeconds()
      )
    );

    // Create axes
    // https://www.amcharts.com/docs/v5/charts/xy-chart/axes/
    let xAxis = chart.xAxes.push(
      am5xy.DateAxis.new(root, {
        maxDeviation: 0.1,
        groupData: false,
        baseInterval: {
          timeUnit: "second",
          count: 60,
        },
        renderer: am5xy.AxisRendererX.new(root, {}),
        tooltip: am5.Tooltip.new(root, {}),
        min: minDate.getTime(),
        max: maxDate.getTime(),
        // strictMinMax: true,
      })
    );

    // Add cursor
    // https://www.amcharts.com/docs/v5/charts/xy-chart/cursor/
    let cursor = chart.set(
      "cursor",
      am5xy.XYCursor.new(root, {
        xAxis: xAxis,
        behavior: "none",
      })
    );
    cursor.lineY.set("visible", false);

    const series_list = [];

    function createAxisAndSeries(startValue, opposite, type, unit, name) {
      let yRenderer = am5xy.AxisRendererY.new(root, {
        opposite: opposite,
      });
      let yAxis = chart.yAxes.push(
        am5xy.ValueAxis.new(root, {
          maxDeviation: 0.1,
          renderer: yRenderer,
          min:type === "Vo"&&0,
        
        })
      );

      if (chart.yAxes.indexOf(yAxis) > 0) {
        yAxis.set("syncWithAxis", chart.yAxes.getIndex(0));
      }

      // Add series
      // https://www.amcharts.com/docs/v5/charts/xy-chart/series/
      let series = chart.series.push(
        am5xy.LineSeries.new(root, {
          name: name,
          xAxis: xAxis,
          yAxis:
            type === "Ibat" || type === "I"
              ? chart.yAxes.getIndex(4)
              : chart.yAxes.getIndex(0),
          valueYField: "value",
          valueXField: "date",
          tooltip: am5.Tooltip.new(root, {
            pointerOrientation: "horizontal",
            labelText: "{valueY} " + unit,
          }),
          legendLabelText: "{name}",
          legendRangeLabelText: "{name}",
          locationX: 0,
          minDistance: type === "P" ? 2 : 4,
          connect: true,
          marginBottom: 10,
          
          
        })
      );
      series_list.push(series);

      series.strokes.template.setAll({ strokeWidth: 1 });

      yRenderer.grid.template.set("strokeOpacity", 0.05);
      yRenderer.labels.template.set("fill", series.get("fill"));
      yRenderer.setAll({
        stroke: series.get("fill"),
        strokeOpacity: 1,
        opacity: 1,
      });

      if (type === "P" || type === "Pbat") {
        series.strokes.template.setAll({
          strokeWidth: 1.5,
        });
        series.fills.template.setAll({
          fillOpacity: 0.5,
          visible: true,
        });
      } else if (
        type === "I" ||
        type === "V" ||
        type === "Ibat" ||
        type === "Vbat" ||
        type === "SOC"
      ) {
        series.strokes.template.setAll({
          strokeWidth: 1,
          // strokeDasharray: [10, 5],
        });
        
      } else if (type === "Pnet") {
        series.strokes.template.set("strokeDasharray", [10, 1]);
      }
     

      // Set up data processor to parse string dates
      // https://www.amcharts.com/docs/v5/concepts/data/#Pre_processing_data
      series.data.processor = am5.DataProcessor.new(root, {
        dateFormat: "yyyy-MM-ddTHH:mm:ss",
        dateFields: ["date"],
      });

      series.data.setAll(generateChartData(startValue, type));
    }

    // add scrollbar
    chart.set(
      "scrollbarX",
      am5.Scrollbar.new(root, {
        orientation: "horizontal",
      })
    );

    let rev_data = data.reverse();
    createAxisAndSeries(
      rev_data,
      false,
      "P",
      "W",
      lang_choiced.pages.byPanel.PanelGroup.Line.Modal.seriesName.P
    );
    createAxisAndSeries(
      rev_data,
      false,
      "Pbat",
      "W",
      lang_choiced.pages.byPanel.PanelGroup.Line.Modal.seriesName.Pbat
    );
    createAxisAndSeries(
      rev_data,
      false,
      "Pnet",
      "W",
      lang_choiced.pages.byPanel.PanelGroup.Line.Modal.seriesName.Pnet
    );
    createAxisAndSeries(
      rev_data,
      true,
      "V",
      "V",
      lang_choiced.pages.byPanel.PanelGroup.Line.Modal.seriesName.V
    );
    createAxisAndSeries(
      rev_data,
      true,
      "I",
      "A",
      lang_choiced.pages.byPanel.PanelGroup.Line.Modal.seriesName.I
    );
    createAxisAndSeries(
      rev_data,
      true,
      "Vbat",
      "V",
      lang_choiced.pages.byPanel.PanelGroup.Line.Modal.seriesName.Vbat
    );
    createAxisAndSeries(
      rev_data,
      true,
      "Ibat",
      "A",
      lang_choiced.pages.byPanel.PanelGroup.Line.Modal.seriesName.Ibat
    );
    createAxisAndSeries(
      rev_data,
      true,
      "Vo",
      "V",
      lang_choiced.pages.byPanel.PanelGroup.Line.Modal.seriesName.Vo
    );
    createAxisAndSeries(
      rev_data,
      true,
      "SOC",
      "%",
      lang_choiced.pages.byPanel.PanelGroup.Line.Modal.seriesName.SOC
    );
    createAxisAndSeries(
      rev_data,
      true,
      "Temp",
      "ºC",
      lang_choiced.pages.byPanel.PanelGroup.Line.Modal.seriesName.Temp
    );
    // console.log(rev_data , "is rev_data")
    cursor.snapToSeries = series_list;

    // Make stuff animate on load
    // https://www.amcharts.com/docs/v5/concepts/animations/
    chart.appear(400, 100);

    // chart._logo.dispose();

    // Generates random data, quite different range
    function generateChartData(values, type) {
      if (type === "P") {
        const x = values.map((value) => ({
          value: am5.math.round(value.product / 100000),
          date: value.date,
        }));
        return x;
      } else if (type === "Pbat") {
        const x = values.map((value) => ({
          value: am5.math.round(value.product_bat / 100000),
          date: value.date,
        }));
        return x;
      } else if (type === "Pnet") {
        const x = values.map((value) => ({
          value:
            am5.math.round(value.product / 100000) +
            am5.math.round(value.product_bat / 100000),
          date: value.date,
        }));
        return x;
      } else if (type === "I") {
        const x = values.map((value) => ({
          value: am5.math.round((value.I / 1000) * 100) / 100,
          date: value.date,
        }));
        return x;
      } else if (type === "Ibat") {
        const x = values.map((value) => ({
          value: am5.math.round((value.Ibat / 1000) * 100) / 100,
          date: value.date,
        }));
        return x;
      } else if (type === "V") {
        const x = values.map((value) => ({
          value: am5.math.round((value.V / 100) * 10) / 10,
          date: value.date,
        }));
        return x;
      } else if (type === "Vbat") {
        const x = values.map((value) => ({
          value: am5.math.round((value.Vbat / 100) * 10) / 10,
          date: value.date,
        }));
        return x;
      } else if (type === "SOC") {
        const x = values.map((value) => ({
          value: value.SOC / 100,
          date: value.date,
        }));
        return x;
      } else if (type === "Temp") {
        const x = values.map((value) => ({
          value: value.Temp,
          date: value.date,
        }));
        return x;
      }else if (type === "Vo") {
        const x = values.map((value) => ({
          value: value.Vo/10,
          date: value.date,
        }));
        return x;
      }
    }
    let legend = chart.children.push(
      am5.Legend.new(root, {
        useDefaultMarker: true,
      })
    );

    legend.markers.template.setup = function (marker) {
      let check = am5.Graphics.new(root, {
        fill: am5.color(0x000000),
        fillOpacity: 1,
        width: 20,
        height: 20,
        layer: 50,
        svgPath:
          "M15.75 2.527c-.61-.468-1.46-.328-1.902.32l-6.325 9.255L4.04 8.328a1.3 1.3 0 0 0-1.922-.062 1.505 1.505 0 0 0-.062 2.043s4.234 4.695 4.843 5.168c.61.468 1.457.328 1.903-.32L16.05 4.55c.445-.653.308-1.555-.301-2.024Zm0 0",
      });

      check.states.create("disabled", {
        fillOpacity: 0,
      });

      marker.children.push(check);
    };

    legend.data.setAll(chart.series.values);

    function toggleAxes(visible, target) {
      target.get("yAxis").setAll({
        visible: visible,
      });
    }

    chart.series.getIndex(3).hide();
    chart.series.getIndex(4).hide();
    chart.series.getIndex(5).hide();
    chart.series.getIndex(6).hide();
    chart.series.getIndex(7).hide();
    chart.series.getIndex(8).hide();
    chart.series.getIndex(9).hide();

    // for (const s of chart.series) s.on("visible", toggleAxes);

    return () => root.dispose();
  });

  return (
    <div>
      {loading ? (
        <div className="animated fadeIn">
          <Loader />
          <p className="text-center">Loading...</p>
        </div>
      ) : (
        ""
      )}
      <div
        id="ByPanelDailyChartData"
        style={{
          minWidth: "100%",
          height: "500px",
          direction: "ltr",
          display: loading ? "none" : "block",
        }}
      ></div>
    </div>
  );
}
export default React.memo(ByPanelDailyChartData);
